export type EducationClass = {
  id: number;
  litera: string;
  parallel: Parallel;
};

export enum Parallel {
  FIRST = 'FIRST',
  SECOND = 'SECOND',
  THIRD = 'THIRD',
  FOURTH = 'FOURTH',
  FIFTH = 'FIFTH',
  SIXTH = 'SIXTH',
  SEVENTH = 'SEVENTH',
  EIGHTH = 'EIGHTH',
  NINTH = 'NINTH',
  TENTH = 'TENTH',
  ELEVENTH = 'ELEVENTH',
}

export type EducationClassListRequest = {
  page?: number;
  size?: number;
  sort?: string[];
  name?: string;
  litera?: string;
  parallel?: Parallel;
  curriculumId?: number;
};
